export class TotalizarRepository {
    private httpService: IHttpService
    constructor(instance: IHttpService) {
        this.httpService = instance;
    }

/**
 * Totaliza los registros de tiempo proporcionados.
 *
 */
    async Totalize(data: {
        start_dtm: string,  //YYYY-MM-DDTHH:mm:ss
        end_dtm: string,    //YYYY-MM-DDTHH:mm:ss
        employee_id?: number,
        punches: {
            id: number,
            punchDateTimeUTC: string, //YYYY-MM-DDTHH:mm:ss
            timeZone: string
        }[]
    }): Promise<any> {
		const response = await this.httpService.post<TKResponse<any>, any>("Totalize", { data });
		return response.data;
	}
}
